

export const processFilesForUpload = async (contenidoQuill) => {
      if (!Array.isArray(contenidoQuill)) {
        console.log("❌ NO ES ARRAY - retornando original");
        return { contenido: contenidoQuill, archivos: [] };
      }

      const archivosExtraidos = [];
      const nombresUsados = []; // Para evitar duplicados
      const contenidoModificado = [...contenidoQuill]; // Copia del contenido para modificar

      // 🔄 Extraer archivos Y normalizar SOLO nombres en el contenido
      for (let i = 0; i < contenidoModificado.length; i++) {
        const item = contenidoModificado[i];
        console.log(`\n🔍 PROCESANDO ITEM ${i}:`);
            
        if (item.insert && typeof item.insert === 'object' && item.insert.archivoOffline) {
          console.log("✅ ENCONTRÓ archivoOffline!");
          const archivoData = item.insert.archivoOffline;
          console.log("archivoData:", archivoData);
                
          try {
            let file = null;
            
            // NORMALIZAR EL NOMBRE DEL ARCHIVO
            const nombreOriginal = archivoData.nombre || archivoData.fileName || 'archivo_sin_nombre';
            const nombreNormalizado = obtenerNombreUnico(nombreOriginal, nombresUsados);
            nombresUsados.push(nombreNormalizado);
            
            console.log(`🔄 NORMALIZANDO NOMBRE: "${nombreOriginal}" → "${nombreNormalizado}"`);
            
            // MÉTODO 1: Si tiene blob URL (formato anterior)
            if (archivoData.urlArchivo && archivoData.urlArchivo.startsWith('blob:')) {
              console.log("🔄 PROCESANDO BLOB URL");
                        
              const response = await fetch(archivoData.urlArchivo);
              const blob = await response.blob();
                        
              file = new File([blob], nombreNormalizado, {
                type: archivoData.fileType
              });
                        
              console.log("✅ File creado desde blob:", file.name, file.size);
            }
            // MÉTODO 2: Si tiene base64 (formato actual)
            else if (archivoData.contenido && archivoData.nombre) {
              console.log("🔄 PROCESANDO BASE64");
              console.log("Nombre original:", archivoData.nombre);
              console.log("Nombre normalizado:", nombreNormalizado);
              console.log("Tipo:", archivoData.tipo);
              console.log("Base64 length:", archivoData.contenido.length);
                        
              // Convertir base64 a Blob
              const base64Data = archivoData.contenido;
              const byteCharacters = atob(base64Data);
              const byteNumbers = new Array(byteCharacters.length);
                        
              for (let j = 0; j < byteCharacters.length; j++) {
                byteNumbers[j] = byteCharacters.charCodeAt(j);
              }
                        
              const byteArray = new Uint8Array(byteNumbers);
              const blob = new Blob([byteArray], { type: archivoData.tipo });
                        
              // Crear File object con nombre normalizado
              file = new File([blob], nombreNormalizado, {
                type: archivoData.tipo
              });
                        
              console.log("✅ File creado desde base64:", file.name, file.size);
            }
            else {
              console.log("❌ Formato de archivo no reconocido");
              console.log("Keys disponibles:", Object.keys(archivoData));
            }
                    
            if (file) {
              archivosExtraidos.push(file);
              
              // 🎯 MODIFICAR SOLO EL NOMBRE: mantener todas las demás propiedades intactas
              contenidoModificado[i] = {
                ...item,
                insert: {
                  ...item.insert,
                  archivoOffline: {
                    ...archivoData, // ← MANTENER TODAS las propiedades originales
                    nombre: nombreNormalizado, // ← Solo cambiar el nombre
                    fileName: nombreNormalizado // ← Y fileName si existe
                  }
                }
              };
              
              console.log("✅ ARCHIVO EXTRAÍDO Y SOLO NOMBRE ACTUALIZADO! Total:", archivosExtraidos.length);
              console.log("📝 Nombre actualizado en contenido:", nombreNormalizado);
              console.log("📝 Propiedades conservadas:", Object.keys(archivoData));
            }
                  
          } catch (error) {
            console.error('❌ Error procesando archivo:', error);
          }
        }
      }

      console.log("\n🎯 === RESULTADO FINAL ===");
      console.log("archivosExtraidos:", archivosExtraidos.length);
      console.log("contenido modificado:", contenidoModificado.length, "items");
      
      archivosExtraidos.forEach((archivo, index) => {
        console.log(`  [${index}]: ${archivo.name} (${archivo.size} bytes)`);
      });

      // Mostrar cambios en el contenido
      console.log("\n📝 === CAMBIOS EN CONTENIDO ===");
      contenidoModificado.forEach((item, index) => {
        if (item.insert && item.insert.archivoOffline) {
          const archivo = item.insert.archivoOffline;
          console.log(`  [${index}]: Nombre actualizado a "${archivo.nombre}"`);
          console.log(`  [${index}]: Propiedades conservadas:`, Object.keys(archivo));
        }
      });

      // ✅ RETORNAR: archivos extraídos + contenido con SOLO nombres normalizados
      return {
        contenido: contenidoModificado,  // ← Contenido con SOLO nombres cambiados
        archivos: archivosExtraidos      // ← Archivos extraídos con nombres normalizados
      };
};

//normalizar archivos aca
function normalizarNombreArchivo(fileName) {
      if (!fileName || typeof fileName !== 'string') {
        return 'archivo_sin_nombre';
      }

      // Separar nombre y extensión
      const lastDotIndex = fileName.lastIndexOf('.');
      let nombre = fileName;
      let extension = '';
      
      if (lastDotIndex > 0) {
        nombre = fileName.substring(0, lastDotIndex);
        extension = fileName.substring(lastDotIndex);
      }

      // Normalizar el nombre (sin la extensión)
      let nombreNormalizado = nombre
        .toLowerCase()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .replace(/\s+/g, '_')
        .replace(/[^a-z0-9_\-]/g, '')
        .replace(/[-_]+/g, '_')
        .replace(/^[-_]+|[-_]+$/g, '');

      if (!nombreNormalizado) {
        nombreNormalizado = 'archivo';
      }

      const maxLength = 200 - extension.length;
      if (nombreNormalizado.length > maxLength) {
        nombreNormalizado = nombreNormalizado.substring(0, maxLength);
      }

      return nombreNormalizado + extension.toLowerCase();
}

//nombre unico de archivo
function obtenerNombreUnico(fileName, existingNames = []) {
      let nombreNormalizado = normalizarNombreArchivo(fileName);
      
      if (!existingNames.includes(nombreNormalizado)) {
        return nombreNormalizado;
      }

      const lastDotIndex = nombreNormalizado.lastIndexOf('.');
      let nombre = nombreNormalizado;
      let extension = '';
      
      if (lastDotIndex > 0) {
        nombre = nombreNormalizado.substring(0, lastDotIndex);
        extension = nombreNormalizado.substring(lastDotIndex);
      }

      let contador = 1;
      let nombreConSufijo;
      
      do {
        nombreConSufijo = `${nombre}_${contador}${extension}`;
        contador++;
      } while (existingNames.includes(nombreConSufijo));

      return nombreConSufijo;
}